// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { type Action, createAsyncThunk, type EnhancedStore } from '@reduxjs/toolkit';
import type { IServiceException } from 'shared/utils/errors.utils';
import type { TAppDispatch } from '.';
import type { TRootState } from './reducers';

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: TRootState;
  dispatch: TAppDispatch;
  rejectValue: IServiceException;
}>();

export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;
export const useAppDispatch = () => useDispatch<TAppDispatch>();

/**
 * Store instance to use outside React components
 */
let storeInstance: EnhancedStore | null = null;

/**
 * Initialize the store - called once when creating it
 */
export const setStoreInstance = (store: EnhancedStore) => {
  storeInstance = store;
};

/**
 * Get the store instance
 */
export const getStoreInstance = (): EnhancedStore => {
  if (!storeInstance) {
    throw new Error('Store has not been initialized. Call setStoreInstance first.');
  }
  return storeInstance;
};

/**
 * Dispatch actions to the store from outside React components
 */
export const dispatchAction = (action: Action) => {
  const store = getStoreInstance();
  store.dispatch(action);
};
